import { Blocs } from '@business/blocs';
import { PaymentType } from '@business/entities/tm';
import { BillsInvoiceSearchParams, TMProviderInvoiceResponse } from '@business/entities/tm/TMProviderInvoiceResponse';
import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { PaginatedController } from '@core/utils/paginated';
import { LoadingState } from '@core/utils/repository/loading_state';
import { forkJoin } from 'rxjs';

export const BILLS_LIST_INITIAL_QUERY: BillsInvoiceSearchParams = {
  page: 1,
  search: '',
  providerId: null,
  paymentTypeStatus: 'all',
};

export class BillsListBloc extends BaseBloc {
  private readonly invoiceBloc = resolve(Blocs.tmProviderInvoice);
  private readonly tmServiceProviderBloc = resolve(Blocs.tmServiceProvider);

  loading = new LoadingState();

  providers$ = this.tmServiceProviderBloc.items$;

  onInit() {
    return forkJoin([this.paginated.fetch().pipe(this.loading.run()), this.tmServiceProviderBloc.fetchServiceProviders()]);
  }

  fetchInvoiceItems = (query?: any) => {
    return this.invoiceBloc.fetchInvoices(query).pipe(this.loading.run({}));
  };

  readonly paginated = new PaginatedController<TMProviderInvoiceResponse, string, BillsInvoiceSearchParams>(
    this.fetchInvoiceItems,
    '',
    BILLS_LIST_INITIAL_QUERY,
  );

  readonly items$ = this.paginated.items$;
  readonly query$ = this.paginated.pageQuery$;

  syncInvoiceToQBO = this.invoiceBloc.syncInvoiceToQBO;
  reSyncInvoiceToSystem = this.invoiceBloc.reSyncInvoiceToSystem;
}
